import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledSpinXSaleBadge = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  top: -3px;
  left: 23px;
  transform: translateX(-50%);

  img {
    width: auto;
    height: 100%;
    max-width: 57px;
    max-height: 39px;
    object-fit: contain;
  }

  .spinx-container {
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    width: 50px;
    padding: 0 8px 0 6px;

    .number {
      color: #fff;
      text-shadow: 1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000,
        -1px 1px 1px #000;
      font-style: normal;
      font-weight: 950;
      line-height: normal;
      width: 100%;
      text-transform: none;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(clamp(4px, 1em * 1.17, 14px));
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    top: -4px;
    left: 32px;

    img {
      max-width: 80px;
      max-height: 55px;
    }

    .spinx-container {
      width: 73px;

      .number {
        font-size: calc(clamp(4px, 1em * 1.67, 20px));
      }
    }
  }
` as any;
